// extracted by mini-css-extract-plugin
export default {"logo":"PublicLogo_logo__9ECVa"};